var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/menu/menu.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Menu, MenuButton, MenuItem, MenuItems, MenuPopover, MenuLink } from '@reach/menu-button';
import { positionDefault, positionRight } from '@reach/popover';
import React from 'react';
import './menu.css';

/** Renders children as a dropdown menu. */
const MenuList = props => /*#__PURE__*/React.createElement(MenuPopover, {
  position: props.position === 'left' ? positionDefault : positionRight,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 22,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement(MenuItems, _extends({
  onKeyDown: event => event.nativeEvent.stopImmediatePropagation(),
  className: "py-1 bg-white dark:bg-primary-900 rounded-lg shadow-menu"
}, props, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 23,
    columnNumber: 5
  }
})));
/** Divides menu items. */


const MenuDivider = () => /*#__PURE__*/React.createElement("hr", {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 32,
    columnNumber: 27
  }
});

export { Menu, MenuButton, MenuDivider, MenuItems, MenuItem, MenuList, MenuLink };